<template>
  <div class="cansancio" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>
    <div class="form-row">
      <h1 class="col-8">Reporte de Cansancio</h1>
      <div class="col-3"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
    </div>

    <div class="row">
      <div class="col-12">
        <label class="col-form-label">Unidades</label>
        <multiselect ref="select" v-model="dispositivosSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="dispositivosObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAll">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAll">Limpiar</button>
      </div>
      <div class="col-12">
        <label class="col-form-label">Grupos</label>
        <multiselect ref="select" v-model="gruposSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="gruposObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
      </div>
      <!--<div class="col-12">
        <label class="col-form-label">Sitios</label>
        <multiselect ref="select" v-model="geocercasSeleccionadas" placeholder="Seleccione los sitios" label="name" track-by="id" :options="geocercasObtenidas" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
      </div>-->
      <div class="col-12">
        <label class="col-form-label">Fechas</label>
      

      </div>
      <div class="col-md-4 mt-4">
        
        <input type="date" class="form-control" v-model="fechaInicio" value="2021-12-06">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" disabled class="form-control" v-model="horaInicio" style="display: none">
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaFin" value="2021-12-07">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" disabled class="form-control" v-model="horaFin" style="display: none">
      </div>
      
    </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>

    <div class="table-responsive mt-4">
      <table  class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Unidad</th>
            <th>Horas encendido</th>
            <th>Horas apagado</th>
            <th>Fecha</th>
            <!--<th>Fecha</th>-->
            <!--<th>Hora del evento</th>-->
            <!--<th>Tiempo en sitio</th>-->
            <!-- <th>Horas motor</th> -->
            <!-- <th>Combustible utilizado</th> -->
          </tr>
        </thead>
        <!--<tbody v-for="item of formatearDatos" v-if="item.type == 'geofenceEnter' && item.geofenceId == item2.id || item.type =='geofenceExit' && item.geofenceId == item2.id">-->
        <tbody v-for="item of formatearDatos" >
           
          <!--<tr v-for="item of formatearDatos" v-if="item.type == 'geofenceEnter' && item.geofenceId == $data.geocercasSeleccionadas[item.geofenceId] || item.type =='geofenceExit' && item.geofenceId == $data.geocercasSeleccionadas[item.geofenceId]">-->
            <tr>
            <!--<td v-for="item3 of geocercasSeleccionadas">{{ item3.name }}</td>-->
            <td>{{ item.nombreUnidad }}</td>
            <!--<td>{{$data.dispositivosSeleccionados[item.deviceId].name}}</td>-->
            <td>{{item.horasencendido}}</td>
            <td>{{item.horasapagado}}</td>
            <!--<td v-if="item.type == 'geofenceEnter'">Entrada a Sitio</td>
            <td v-else>Salida de Sitio</td>-->
            <!--<td v-if="item.nombreEvento == 'geofenceEnter'">Entrada a Sitio</td>
            <td v-else>Salida de Sitio</td>-->
            <!--<td>{{item.nombreEvento}}</td>-->
            <td>{{item.fecha}}</td>
            <!--<td>{{item.hora}}</td>-->
            <!--<td>Tiempo en sitio</td>-->            
            <!--<td v-for="item2 of dispositivosSeleccionados">{{ item2.name}} </td>-->
            
            <!--<td>{{ item.serverTime }}</td>
            <td>{{ item.maintenanceId }}</td>
            <td>{{}}</td>-->
            <!-- <td>{{ item.engineHours }}</td> -->
            <!-- <td>{{ item.spentFuel }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
  data() {
    return {
      dispositivosObtenidos: [],
      dispositivosSeleccionados: [],
      dispositivosSeleccionados2: [],
      gruposObtenidos: [],
      gruposSeleccionados: [],
      gruposSeleccionados2: [],
      geocercasObtenidas: [],
      geocercasSeleccionadas: [],
      geocercasSeleccionadas2: [],
      fechaInicio: '2021-12-06',
      horaInicio: '00:00',
      fechaFin: '2021-12-07',
      horaFin: '',
      datosReporte: []
    }
  },

  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades,
      catGeocercas: state => state.catalogos.catGeocercas
    }),

    ...mapState(["cargando"]),

     formatearIds() {
      //let data = '';
      var index = 0;
      //this.dispositivosSeleccionados = [];
      for (let item of this.dispositivosSeleccionados) {
        //(index == 0) ? data += 'deviceId=' + item.id : data += '&deviceId=' + item.id;
        this.dispositivosSeleccionados2.push(item.nombre);
        index++;
      }
      return this.dispositivosSeleccionados2;
    },

    formatearIdGrupo() {
       var index = 0;
      for (let item of this.gruposSeleccionados) {
        this.gruposSeleccionados2.push(item.grupo);
        index++;
      }
      return this.gruposSeleccionados2;
    },
    
    formatearIdGeocerca() {
       var index = 0;
      for (let item of this.geocercasSeleccionadas) {
        this.geocercasSeleccionadas2.push(item.id);
        index++;
      }
      return this.geocercasSeleccionadas2;
    },

     formatearDatos() {
      var index1 = 0;
      var index2 = 0; 
     // var item;
      //var item5;
      //var item5;           
      
    //  for (var item4 of this.dispositivosSeleccionados) {
         //    console.log(item4.name);
      //}
        
              // for (var item5 of this.dispositivosSeleccionados) {     
                
                  //console.log(item5.name);
             //     index2++;
                for ( var item of this.datosReporte) {
                     
                      //item.datos.NoEmpleado = item.datos.NoEmpleado;
                      //item.maintenanceId = (item.serverTime).substr(11,8);
                      //item.serverTime = (item.serverTime).slice(0,10);
                      //console.log(this.formatearIds);
                     /* if(item.nombreEvento == 'geofenceEnter')
                      {
                        item.nombreEvento = "Entrada a sitio";
                      }
                      else
                      {
                        item.nombreEvento = "Salida de Sitio";
                      }*/
                      //item.NoEmpleado = item.NoEmpleado;
                      item.fecha = (item.fecha).slice(0,10);
                      index1++;
                      
                    }
                    //var item5 = item5.name;
                    //  var item5.name = item5.name;
                    //index2++;
                    
    //}
          
     return this.datosReporte;
                       
      
    }
  },

  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"],["obtenerGeocercas"]),
    ...mapMutations(["setearCargando"]),

    obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, JSON.parse(localStorage.user))
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },

    generarReporte() {
      if (this.fechaInicio !='' && this.fechaFin !='') {

        if(this.dispositivosSeleccionados.length || this.gruposSeleccionados.length){
        let fechaInicio = this.fechaInicio;
        let fechaFin = this.fechaFin;
        //fecha.setDate(fecha.getDate() + 1);
        console.log(fechaInicio);
        console.log(fechaFin);
        

        this.setearCargando(true);
        this.reporteGeocercas(fechaInicio, fechaFin);

        }else{
          alert('Debe seleccionar ya sean grupos o unidades');

        }
      }else{
          alert('Debe seleccionar la fecha y al menos una unidad o grupo');

        }
    },

    reporteDispositivos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIds}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    
     reporteGeocercas(fechaInicio, fechaFin){
         let params = new URLSearchParams();
         params.append("fecha_inicial", fechaInicio);
      params.append("fecha_final", fechaFin);
      params.append("unidad", 'B1920-GDL');
      let headers = { headers: { "Content-Type": "application/json"} };  
      axios.post(`${url3}cansancio_rango`,params)
      .then(response => {
          this.datosReporte = response.data.datos;
          this.removeAll();
          this.setearCargando(false);
          //console.log(this.datosReporte)
          //for (let item of this.datosReporte) {
        //(index == 0) ? data +=  item.id : data += item.id;
        //index++;
      //}
          //if (this.datosReporte.item == 0)
          //{
            
          //}
          //else{
           // this.setearCargando(false);
          //}
          
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
          
        });
    },
    
     reporteGeocercasGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/events?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },

    reporteGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    selectAll() {
      this.dispositivosSeleccionados = [];
      for (let item of this.dispositivosObtenidos) {
          this.dispositivosSeleccionados.push(item);
      }
      
    },

    removeAll() {
      this.fechaInicio='';
      this.dispositivosSeleccionados = [];
      this.dispositivosSeleccionados2 = [];
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = []; 
      this.geocercasSeleccionadas = [];         
      this.geocercasSeleccionadas2 = [];  
    },

    exportExcel() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['nombreUnidad', 'horasencendido', 'horasapagado', 'fecha'] } );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'Horas Encendido';
        data['C1'].v = 'Horas Apagado';
        data['D1'].v = 'Fecha';
        //data['E1'].v = 'Fecha';
        //data['F1'].v = 'Hora';
        //data['G1'].v = 'odometroFinal';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    obtenerDispositivos() {
      this.setearCargando(true);
      axios.get(`${url}devices`, JSON.parse(localStorage.user))
        .then(response => {
          this.dispositivosObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    obtenerGrupos() {
      this.setearCargando(true);
      axios.get(`${url}groups`, JSON.parse(localStorage.user))
        .then(response => {
          this.gruposObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
    
     obtenerGeocercas() {
      this.setearCargando(true);
      axios.get(`${url}geofences`, JSON.parse(localStorage.user))
        .then(response => {
          this.geocercasObtenidas = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
  },

  created() {
    this.obtenerDispositivos();
    this.obtenerGrupos();
    this.obtenerGeocercas();
    // this.obtenerUnidades();
    // this.obtenerSesion();
  },

  mounted() {
    // this.obtenerKilometraje();
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}
</script>
<style>
  .cansancio{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>